import MuiTableHead from "@material-ui/core/TableHead";

const TableHead = MuiTableHead;

TableHead.defaultProps = {
  ...MuiTableHead.defaultProps
};

export default TableHead;
